var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElFrontCloseRearOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0V0C13.1046 0 14 0.895431 14 2V4C14 5.10457 13.1046 6 12 6V6V0Z",
    fill: "#FAAD14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 8.89543 0.895431 8 2 8H6V14H2C0.89543 14 0 13.1046 0 12V10Z",
    fill: "#449FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H12C13.1046 8 14 8.89543 14 10V12C14 13.1046 13.1046 14 12 14H8V8Z",
    fill: "#449FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.89543 0.895431 0 2 0V0V6V6C0.895431 6 0 5.10457 0 4V2Z",
    fill: "#FAAD14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElFrontCloseRearOpen);
export default __webpack_public_path__ + "static/media/el-front-close-rear-open.772c6ccc8160b93d603b6238877928a3.svg";
export { ForwardRef as ReactComponent };